// 手机号
export const rMobilePhone = /^1\d{10}$/

// 邮箱（与 server rEmail 保持一致）
export const rEmail = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/

// 账号
export const rAccount = /^([\da-z]){4,11}$/i

// 密码 支持字母/数字/下划线(6-16)
export const rPassword = /^\w{6,16}$/

// 验证码
export const rVerCode = /^\d{4}$/
